import authHeader from "./auth_header";
import axiosInstance from './axios_instance';


const ApiPath = "/api/address_search";

export default async function searchAddress(navigate: any, query: string, type: string) {
    const headers = authHeader(navigate);
    const params = {
        query,
        type
    }
    return await axiosInstance(navigate).get(ApiPath, { headers, params });
}